import React, { useState, useEffect } from "react";
import classes from "./SavingsExcelUpload.module.css";
import api, { BASE_URL, withCompanyId } from "../../Components/API/Api";
import { useNavigate } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import crop from "../../Assets/repoort.png";
import verified from "../../Assets/verified.svg";
import uploadIcon from "../../Assets/uppload.svg";
import CurrencyInput from 'react-currency-input-field';
import axios from "axios";
import checkersicon from "../../Assets/checkers.svg";
import closebtn from "../../Assets/close-btn.svg";

function SavingsUpload({ isOpen, onClose, onSuccess }) {
  const [rows, setRows] = useState([
    { accountId: "", accountDisplay: "", accountCode: "", amount: "", showDropdown: false },
  ]);
const [downloading, setDownloading] = useState(false);
  const [reference, setReference] = useState("");
  const [duration, setDuration] = useState("");
  const [interestAmount, setInterestAmount] = useState(0.00);
  const [monthlyDeduction, setMonthlyDeduction] = useState(0.00);
  const [repaymentAmount, setRepaymentAmount] = useState(0.00);
  const [loanInterest, setLoanInterest] = useState('');
  const [fetchedLoanInterest, setFetchedLoanInterest] = useState(0.00);
  const [supplierSearch, setSupplierSearch] = useState("");
  const [showSupplierDropdown, setShowSupplierDropdown] = useState(false);
  const navigate = useNavigate();
  const [debitSearch, setDebitSearch] = useState("");
  const [showDebitDropdown, setShowDebitDropdown] = useState(false);
  const [transactionDate, setTransactionDate] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [accountsLoading, setAccountsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [description, setDescription] = useState("");
  const [debitAccount, setDebitAccount] = useState("");
  const [outstandingAmount, setOutstandingAmount] = useState("");
  const [selectedLoanAccount, setSelectedLoanAccount] = useState("");
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [loanOptions, setLoanOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [paymentTypes, setPaymentTypes] = useState([]);
  const [paymentTypesLoading, setPaymentTypesLoading] = useState(false);
  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const [supplierLoading, setSupplierLoading] = useState(false);
  const [paymentToLoading, setPaymentToLoading] = useState(false);
  const paymentTypeLower = (selectedPaymentType || "").toLowerCase();
  const [creditAccounts, setCreditAccounts] = useState([]);
const [loanProducts, setLoanProducts] = useState([]);
const [selectedLoanProducts, setSelectedLoanProducts] = useState('');
const [loanProductsLoading, setLoanProductsLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState(""); 
  const [receiptTypes, setReceiptTypes] = useState([]);
  const [receiptTypesLoading, setReceiptTypesLoading] = useState(false);
  const [paymentSearch, setPaymentSearch] = useState("");
  const [showPaymentDropdown, setShowPaymentDropdown] = useState(false);
  const [expenseOptions, setExpenseOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [paymentModes, setPaymentModes] = useState([]);
  const [receiptType, setReceiptType] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [debitAccountsLoading, setDebitAccountsLoading] = useState(false);
  const [supportingDocument, setSupportingDocument] = useState(null);
  const [supportingError, setSupportingError] = useState("");
  const [payableAccounts, setPayableAccounts] = useState([]);
  const [payableAccountsLoading, setPayableAccountsLoading] = useState(false);
  const [pendingInvoicesMap, setPendingInvoicesMap] = useState({});
    const [bankAccounts, setBankAccounts] = useState([]);
    const [bankAccount, setBankAccount] = useState([]);
      const [loadingDropdowns, setLoadingDropdowns] = useState(true);

const handleFileChange = (e) => {
  const file = e.target.files?.[0];

  if (!file) {
    setSupportingDocument(null);
    return;
  }

  const allowedTypes = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
    "application/vnd.ms-excel", // xls
    "text/csv", // csv
  ];

  const extension = file.name.split(".").pop()?.toLowerCase();

  if (
    !allowedTypes.includes(file.type) &&
    !["xlsx", "xls", "csv"].includes(extension)
  ) {
    Swal.fire({
      icon: "error",
      title: "Invalid File",
      text: "Only Excel (.xlsx, .xls) or CSV files are allowed.",
    });
    e.target.value = "";
    return;
  }

  setSupportingDocument(file);
};

  // === Reset all form fields to initial state ===
  const resetFormFields = () => {
    setRows([
      { accountId: "", accountDisplay: "", accountCode: "", amount: "", showDropdown: false },
    ]);
    setReference("");
    setSupplierSearch("");
    setShowSupplierDropdown(false);
    setDebitSearch("");
    setShowDebitDropdown(false);
    setTransactionDate("");
    setDescription("");
    setDebitAccount("");
    setOutstandingAmount("");
    setSelectedLoanAccount("");
    setSelectedPaymentType("");
    setPaymentSearch("");
    setShowPaymentDropdown(false);
    setTotalAmount("");
    setSelectedCurrency("");
    setSelectedPaymentMode("");
    setSupportingDocument(null);
    setSupportingError("");

    // Set NGN as default currency if available
    const ngnCurrency = currencyOptions.find(c => c.code === "NGN");
    if (ngnCurrency) setSelectedCurrency(ngnCurrency.id);
  };

  // keep handlePrinter as-is
  const handlePrinter = () => {
    const receiptData = {
      reference,
      transactionDate,
      description,
      selectedCurrency,
      selectedPaymentMode,
      debitAccount,
      totalAmount,
      rows,
    };

    navigate("/preview", {
      state: { invoice: receiptData },
    });
  };

  // --- Update outstandingAmount when reference (customer selection) changes ---
  useEffect(() => {
    if (!receiptType?.toLowerCase()?.includes("credit customer")) {
      setOutstandingAmount("");
      return;
    }

    if (!reference) {
      setOutstandingAmount("");
      return;
    }

    const customerObj = customerOptions.find(c => String(c.id) === String(reference));
    const balance = customerObj?.balance ?? 0;
    setOutstandingAmount(String(Number(balance) || 0));
  }, [reference, customerOptions, receiptType]);

  // --- Auto-fill totalAmount when supplier is selected for "payment from payables" ---
  useEffect(() => {
    const type = (selectedPaymentType || "").toLowerCase().trim();
    
    if (!type.includes("payment from payables")) {
      return;
    }

    if (!reference) {
      setTotalAmount("");
      setRows((prev) => {
        if (!prev.length) return prev;
        const newRows = [...prev];
        newRows[0] = {
          ...newRows[0],
          amount: "",
        };
        return newRows;
      });
      return;
    }

    const invoiceData = pendingInvoicesMap[reference];
    if (invoiceData) {
      const balance = String(invoiceData.balance || 0);
      setTotalAmount(balance);
      setRows((prev) => {
        if (!prev.length) {
          return [{ accountId: "", accountDisplay: "", accountCode: "", amount: balance, showDropdown: false }];
        }
        const newRows = [...prev];
        newRows[0] = {
          ...newRows[0],
          amount: balance,
        };
        return newRows;
      });
    } else {
      setTotalAmount("");
      setRows((prev) => {
        if (!prev.length) return prev;
        const newRows = [...prev];
        newRows[0] = {
          ...newRows[0],
          amount: "",
        };
        return newRows;
      });
    }
  }, [reference, pendingInvoicesMap, selectedPaymentType]);

  // --- Auto-fill Account Name and Account Code when invoice is selected for "payment from payables" ---
  useEffect(() => {
    const type = (selectedPaymentType || "").toLowerCase().trim();
    
    if (!type.includes("payment from payables")) {
      return;
    }

    if (!reference) {
      // Reset first row when no reference is selected
      setRows((prev) => {
        const newRows = [...prev];
        if (newRows[0]) {
          newRows[0] = {
            ...newRows[0],
            accountId: "",
            accountDisplay: "",
            accountCode: "",
          };
        }
        return newRows;
      });
      return;
    }

    const invoiceData = pendingInvoicesMap[reference];
    if (invoiceData && invoiceData.fullInvoice) {
      const invoice = invoiceData.fullInvoice;
      
      // Get items from invoice (try multiple field names)
      let items = invoice.items || invoice.line_items || invoice.purchase_order_items || invoice.invoice_items || [];
      
      if (Array.isArray(items) && items.length > 0) {
        const firstItem = items[0];
        
        // Get account information from the first item
        let account = null;
        
        // Try to get account from different possible locations
        if (firstItem.account && typeof firstItem.account === 'object') {
          account = firstItem.account;
        } else if (firstItem.debit_gl && typeof firstItem.debit_gl === 'object') {
          account = firstItem.debit_gl;
        }
        
        if (account) {
          const gl_name = account.gl_name || account.name || account.account_name || "";
          const gl_code = account.gl_code || account.code || "";
          const accountId = account.id || "";
          
          // Update the first row with auto-filled account information
          setRows((prev) => {
            const newRows = [...prev];
            if (newRows[0]) {
              newRows[0] = {
                ...newRows[0],
                accountId: accountId,
                accountDisplay: gl_name,
                accountCode: gl_code,
              };
            }
            return newRows;
          });
          
          console.log("✅ Auto-filled account from invoice item:", {
            gl_name,
            gl_code,
            accountId,
          });
        }
      }
    }
  }, [reference, pendingInvoicesMap, selectedPaymentType]);

  // --- Fetch customers (only when receiptType includes credit customer) ---
  useEffect(() => {
    const fetchCustomers = async () => {
      if (!receiptType?.toLowerCase()?.includes("credit customer")) return;

      try {
        setCustomerLoading(true);
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/customer/get');

        if (res.data && Array.isArray(res.data.data)) {
          setCustomerOptions(res.data.data);
        } else {
          setCustomerOptions([]);
        }
      } catch (err) {
        console.error("Error fetching customers:", err);
        setCustomerOptions([]);
      } finally {
        setCustomerLoading(false);
      }
    };

    fetchCustomers();
  }, [receiptType]);

  // --- Fetch loans (when receiptType includes loan repayment) ---
  useEffect(() => {
    const fetchLoanOptions = async () => {
      if (!receiptType?.toLowerCase()?.includes("loan repayment")) return;

      try {
        setPaymentToLoading(true);
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/loans');

        if (res.data && Array.isArray(res.data.data)) {
          setLoanOptions(res.data.data);
        } else {
          setLoanOptions([]);
        }
      } catch (err) {
        console.error("Error fetching loans:", err);
        setLoanOptions([]);
      } finally {
        setPaymentToLoading(false);
      }
    };

    fetchLoanOptions();
  }, [receiptType]);

  // --- Fetch employees (when receiptType includes employee payment) ---
  useEffect(() => {
    const fetchEmployeeOptions = async () => {
      if (!receiptType?.toLowerCase()?.includes("employee payment")) return;

      try {
        setPaymentToLoading(true);
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/employee/paginated');

        // Handle paginated response: { status, message, data: { current_page, data: [...], ... } }
        if (res.data && res.data.data?.data && Array.isArray(res.data.data.data)) {
          setEmployeeOptions(res.data.data.data);
        } else {
          setEmployeeOptions([]);
        }
      } catch (err) {
        console.error("Error fetching employees:", err);
        setEmployeeOptions([]);
      } finally {
        setPaymentToLoading(false);
      }
    };

    fetchEmployeeOptions();
  }, [receiptType]);

  // --- Fetch payment types ---
  useEffect(() => {
    const fetchPaymentTypes = async () => {
      setPaymentTypesLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/member', { params: { name: 'payment' } });
        if (res.data && Array.isArray(res.data.data)) {
          setPaymentTypes(res.data.data);
        } else {
          setPaymentTypes([]);
        }
      } catch (err) {
        setPaymentTypes([]);
      } finally {
        setPaymentTypesLoading(false);
      }
    };
    fetchPaymentTypes();
  }, []);

  useEffect(() => {
    const fetchLoanProducts = async () => {
      setLoanProductsLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/loan_account');
        if (res.data && Array.isArray(res.data.data)) {
          setLoanProducts(res.data.data);
        } else {
          setLoanProducts([]);
        }
      } catch (err) {
        setLoanProducts([]);
      } finally {
        setLoanProductsLoading(false);
      }
    };
    fetchLoanProducts();
  }, []);

 useEffect(() => {
  const principal = Number(
    String(totalAmount || "0").replace(/,/g, "")
  );

  const rate = Number(loanInterest || 0);

  const interest = (rate / 100) * principal;

  setInterestAmount(
    isNaN(interest)
      ? "0.00"
      : interest.toFixed(2)
  );
}, [loanInterest, totalAmount]);
    
    
    useEffect(() => {
  const principal = Number(
    String(totalAmount || "0").replace(/,/g, "")
  );

  const interest = Number(
    String(interestAmount || "0").replace(/,/g, "")
  );

  const totalRepayment = principal + interest;

  setRepaymentAmount(
    isNaN(totalRepayment)
      ? "0.00"
      : totalRepayment.toFixed(2)
  );
}, [totalAmount, interestAmount]);
    
    useEffect(() => {
  const repayment = Number(
    String(repaymentAmount || "0").replace(/,/g, "")
  );

  const months = Number(duration || 0);

  if (!months) {
    setMonthlyDeduction("0.00");
    return;
  }

  const monthly = repayment / months;

  setMonthlyDeduction(
    isNaN(monthly)
      ? "0.00"
      : monthly.toFixed(2)
  );
}, [repaymentAmount, duration]);


  // --- Fetch suppliers when selectedPaymentType includes supplier or payable ---
  useEffect(() => {
    const fetchSuppliers = async () => {
      const type = (selectedPaymentType || "").toLowerCase().trim();

      // Handle "payment from payables" - fetch from pending purchase invoices endpoint
      if (type.includes("payment from payables")) {
        setSupplierLoading(true);
        try {
          const token = localStorage.getItem("authToken");
          const res = await api.get('/v1/retrieve-pending-purchase-invoices');

          const invoices = res?.data?.data;
          if (Array.isArray(invoices)) {
            const invoiceMap = {};
            const options = [];
            const processedSuppliers = new Map();

            // Process invoices to group by supplier and create display options
            invoices.forEach((invoice) => {
              const invoiceId = String(invoice.id);
              const supplierName = invoice.supplier?.name || `Supplier ${invoice.supplier_id}`;
              const invoiceNumber = invoice.invoice_number;
              const balance = invoice.balance;
              
              // Store invoice data by its ID
              invoiceMap[invoiceId] = {
                id: invoiceId,
                invoiceId,
                supplierName,
                invoiceNumber,
                balance,
                fullInvoice: invoice,
              };

              // Create display option: "Supplier Name (Invoice Number)"
              const displayLabel = `${supplierName} (${invoiceNumber})`;
              options.push({
                id: invoiceId,
                name: displayLabel,
                balance,
              });
            });

            // Log invoice structure for debugging item extraction
            console.log("📦 Pending invoices API response structure:", {
              firstInvoice: invoices[0],
              allInvoices: invoices
            });

            setPendingInvoicesMap(invoiceMap);
            setSupplierOptions(options);
          } else {
            setPendingInvoicesMap({});
            setSupplierOptions([]);
          }
        } catch (err) {
          console.error("Error fetching pending purchase invoices:", err);
          setPendingInvoicesMap({});
          setSupplierOptions([]);
        } finally {
          setSupplierLoading(false);
        }
        return;
      }

      // Original logic for regular supplier selection
      if (!type.includes("supplier") && !type.includes("payable")) {
        setSupplierOptions([]);
        setPendingInvoicesMap({});
        return;
      }

      setSupplierLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/beneficiary');

        const suppliers = res?.data?.data;
        if (Array.isArray(suppliers)) {
          const options = suppliers.map((s) => ({
            id: s.id,
            name: s.supplier_name || s.name || `Supplier ${s.id}`,
          }));
          setSupplierOptions(options);
          setPendingInvoicesMap({});
        } else {
          setSupplierOptions([]);
          setPendingInvoicesMap({});
        }
      } catch (err) {
        console.error("Error fetching suppliers:", err);
        setSupplierOptions([]);
        setPendingInvoicesMap({});
      } finally {
        setSupplierLoading(false);
      }
    };

    fetchSuppliers();
  }, [selectedPaymentType]);

  // --- Fetch Account Names and Codes ---
  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/get-expense-accounts');
        if (res.data && res.data.status && Array.isArray(res.data.data)) {
          setAccounts(res.data.data);
        }
      } catch (err) {
        console.error("Failed to fetch expense accounts", err);
      }
    };
    fetchAccounts();
  }, []);

  // --- Fetch Payable Accounts when payment type includes "payable" ---
  useEffect(() => {
    const fetchPayableAccounts = async () => {
      const type = (selectedPaymentType || "").toLowerCase().trim();

      if (!type.includes("payable")) {
        setPayableAccounts([]);
        return;
      }

      setPayableAccountsLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/get-payable-accounts');

        if (res.data && Array.isArray(res.data.data)) {
          setPayableAccounts(res.data.data);
        } else {
          setPayableAccounts([]);
        }
      } catch (err) {
        console.error("Error fetching payable accounts:", err);
        setPayableAccounts([]);
      } finally {
        setPayableAccountsLoading(false);
      }
    };

    fetchPayableAccounts();
  }, [selectedPaymentType]);

  // --- Fetch Payment Methods ---
  useEffect(() => {
    const fetchPaymentModes = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/income/get-payment-method');

        if (res.data && Array.isArray(res.data.data)) {
          setPaymentModes(res.data.data);
        } else {
          setPaymentModes([]);
        }
      } catch (err) {
        console.error("Error fetching payment methods:", err);
        setPaymentModes([]);
      }
    };
    fetchPaymentModes();
  }, []);

   useEffect(() => {
      const fetchCurrencies = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const res = await api.get('/v1/fetch-all-currencies');
  
          if (res.data && Array.isArray(res.data.data)) {
            setCurrencyOptions(res.data.data);
  
            // ✅ Set NGN as default
            const ngnCurrency = res.data.data.find(c => c.code === "NGN");
            if (ngnCurrency) setSelectedCurrency(ngnCurrency.id);
          }
        } catch (err) {
          console.error("Error fetching currencies:", err);
        }
      };
      fetchCurrencies();
    }, []);

   useEffect(() => {
  const fetchCreditAccounts = async () => {
    setDebitAccountsLoading(true);

    try {
      const res = await api.get("/v1/bank-accounts");

      // const creditAccounts = (res.data?.data || []).map((acc) => ({
      //   value: acc.id,
      //   label: acc.gl_name || acc.name || acc.account_name,
      //   gl_code: acc.gl_code || acc.code,
      //   fullAccount: acc,
      // }));
      const creditAccounts = res.data?.data || [];
      

      setBankAccounts(creditAccounts);
    } catch (error) {
      console.error("Error fetching bank accounts:", error);
      setBankAccounts([]);
    } finally {
      // setDebitAccountsLoading(false);
      setLoadingDropdowns(false);
    }
  };

  fetchCreditAccounts();
}, []);

  // --- Fetch Currencies ---
  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/fetch-all-currencies');

        if (res.data && Array.isArray(res.data.data)) {
          setCurrencyOptions(res.data.data);

          // ✅ Set NGN as default
          const ngnCurrency = res.data.data.find(c => c.code === "NGN");
          if (ngnCurrency) setSelectedCurrency(ngnCurrency.id);
        }
      } catch (err) {
        console.error("Error fetching currencies:", err);
      }
    };
    fetchCurrencies();
  }, []);

  useEffect(() => {
    const fetchCreditAccounts = async () => {
      setDebitAccountsLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/bank-accounts');

        if (res.data && Array.isArray(res.data.data)) {
          const creditAccounts = res.data.data.map((acc) => ({
            value: acc.id,
            label: acc.gl_name || acc.name || acc.account_name,
            gl_code: acc.gl_code || acc.code,
            fullAccount: acc,
          }));
          setCreditAccounts(creditAccounts);
        } else {
          setCreditAccounts([]);
        }
      } catch (error) {
        console.error("Error fetching credit accounts:", error);
        setCreditAccounts([]);
      } finally {
        setDebitAccountsLoading(false);
      }
    };

    if (isOpen) fetchCreditAccounts();
  }, [isOpen]);

  if (!isOpen) return null;

  // === TABLE HANDLERS ===
  const addLine = () => {
    setRows((prev) => [
      ...prev,
      { accountId: "", accountDisplay: "", amount: "", showDropdown: false },
    ]);
  };

  const handleValueChange = (value, name, values) => {
      setTotalAmount(value);
    };
  const handleValueChange1 = (value, name, values) => {
      setInterestAmount(value);
    };
  const handleValueChange2 = (value, name, values) => {
      setRepaymentAmount(value);
    };
  const handleValueChange3 = (value, name, values) => {
      setMonthlyDeduction(value);
    };



  const duplicateRow = (index) => {
    setRows((prev) => {
      const newRows = [...prev];
      const emptyRow = {
        accountId: "",
        accountDisplay: "",
        amount: "",
        showDropdown: false,
      };
      newRows.splice(index + 1, 0, emptyRow);
      return newRows;
    });
  };

  const removeRow = (index) => {
    setRows((prev) => {
      if (prev.length === 1) return prev;
      return prev.filter((_, i) => i !== index);
    });
  };

  const handleChange = (index, field, value) => {
    setRows((prev) => {
      const newRows = [...prev];
      const row = { ...newRows[index] };

      if (field === "showDropdown") {
        row.showDropdown = value;
      } else if (field === "account") {
        row.accountId = value?.id ?? "";
        row.accountDisplay = `${value?.gl_name ?? value?.name ?? ""}`;
        row.accountCode = value?.gl_code ?? value?.code ?? "";
        row.showDropdown = false;
      } else if (field === "accountDisplay") {
        row.accountDisplay = value;
        row.accountId = "";
        row.accountCode = "";
        row.showDropdown = true;
      } else if (field === "amount") {
        row.amount = value;
      }

      newRows[index] = row;
      return newRows;
    });
  };

  const totalDebit = parseFloat(totalAmount || 0);
  const totalCredit = rows.reduce(
    (sum, r) => sum + (parseFloat(r.amount) || 0),
    0
  );
  const isBalanced = totalDebit === totalCredit;

  // === handleSubmit ===
 const handleSubmit = async () => {
  // e.preventDefault();

 
  setIsSaving(true);

  try {
    const companyId =
      localStorage.getItem("company_id") ||
      localStorage.getItem("companyId");

    // Bank account selected from dropdown
    // let bankId = "";

    // try {
    //   const bankData = JSON.parse(bankAccount);
    //   bankId = bankData.id;
    // } catch {
    //   bankId = debitAccount;
    // }
    const bankAccountId = bankAccount;
    const formData = new FormData();

    // (param: company_id, transaction_date, bank)

    formData.append("company_id", companyId);

    // formData.append("loan_name", selectedLoanProducts);
    formData.append("bank", bankAccount);
    
    formData.append("transaction_date", transactionDate);

    
    // formData.append("bank", bankId);
    if (supportingDocument) {
    formData.append("file", supportingDocument);
}

    console.log("Disbursement Application Payload");

    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    const response = await api.post(
      "/v1/customer/upload-savings",
      withCompanyId(formData),
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

   if (response.status === 200 || response.status === 201) {
  // Reset form
  resetFormFields();

  // Close the modal immediately
  onClose();

  // Refresh the loan application table
  if (onSuccess) {
    await onSuccess();
  }
}
await Swal.fire({
    imageUrl: verified,
    title: "Success",
    text: response.data.message,
    confirmButtonColor: "#16A34A",
  });

  } catch (error) {
    console.error(error);
    alert(typeof error.response?.data?.message === "object"
          ? Object.values(error.response.data.message)
              .flat()
              .join(", ")
          : error.response?.data?.message ||
            "An error occurred while submitting the application.",)

    // Swal.fire({
    //   imageUrl: crop,
    //   title: "Submission Failed",
    //   text:
    //     typeof error.response?.data?.message === "object"
    //       ? Object.values(error.response.data.message)
    //           .flat()
    //           .join(", ")
    //       : error.response?.data?.message ||
    //         "An error occurred while submitting the application.",
    // });
  } finally {
    setIsSaving(false);
  }
};



const downloadTemplate = async () => {
  setDownloading(true);
  try {
    const token = localStorage.getItem('authToken');
     const companyId =
      localStorage.getItem("company_id") ||
      localStorage.getItem("companyId");

    const res = await axios.get(`${BASE_URL}/v1/download-member-upload-template?company_id=${companyId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/octet-stream',
      },
      responseType: 'blob', // Tells Axios to handle binary data
    });

    // 1. Check if the server returned a JSON error instead of a file
    if (res.data.type === 'application/json') {
      const text = await res.data.text();
      const errorData = JSON.parse(text);
      throw new Error(errorData.message || 'Server returned an error.');
    }

    // 2. Use res.data directly since it's already a Blob
    const url = window.URL.createObjectURL(res.data);
    const link = document.createElement('a');
    
    // 3. Extract filename safely
    const disposition = res.headers['content-disposition'];
    let filename = 'members_database.xlsx';
    if (disposition) {
      const match = disposition.match(/filename\*=UTF-8''(.+)|filename="?([^";]+)"?/);
      if (match) filename = decodeURIComponent(match[1] || match[2]);
    }
    
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    
    // 4. Clean up
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error(error);
    Swal.fire({ 
      icon: 'error', 
      title: 'Download Failed', 
      text: error.message || 'Unable to download template.' 
    });
  } finally {
    setDownloading(false);
  }
};

 

  return (
    <div className={classes.modalOverlay}>
      <div className={classes.modalContent}>
          <h3 className={classes.title}>Upload Member Savings</h3>
        <h3 className={classes.titlesd} > Three steps to upload your members' savings data</h3>
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
         
          borderTop: '1px solid #D1D5DB'
        }}>
          <div style={{
             marginTop: 40,
          }}/>
           <div className={classes.instRow}>
            <img src={checkersicon} alt="checkers" />
            <p className={classes.instTxt}>Template downloaded - now upload your completed file below </p>
          </div>
        </div>
        
        <div className={classes.topRow}>
         <div className={classes.Group3}>
  {/* <label>File</label> */}
<div style={{
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: 10,
}}>

  <div
    className={classes.uploadContainer}
    onClick={() => document.getElementById("excelUpload").click()}
  >
    <div className={classes.uploadIcon}>
      <img src={uploadIcon} alt="Upload" style={{width: 50, objectFit: 'contain', paddingLeft: 10}}/>
    </div>

    <div>
      <h4 style={{
        fontSize: 14,

      }}>
        {supportingDocument
          ? supportingDocument.name
          : "Click to upload your completed file"}
      </h4>

      <p>or drag and drop .xlsx, .xls accepted</p>
    </div>
  </div>
</div>

  <input
    id="excelUpload"
    type="file"
    accept=".xlsx,.xls,.csv"
    onChange={handleFileChange}
    style={{ display: "none" }}
  />
</div>
          <div className={classes.Group3}>
            {/* <label>Loan Product</label>
           <select
  value={selectedLoanProducts}
  onChange={(e) => {
    const selectedId = e.target.value;

    setSelectedLoanProducts(selectedId);

    const selectedLoan = loanProducts.find(
      (loan) => loan.id.toString() === selectedId
    );

    if (selectedLoan) {
      setFetchedLoanInterest(selectedLoan.interest_rate);
      setLoanInterest(selectedLoan.interest_rate);
    }
  }}
>
  <option value="">Select Product</option>
  {loanProductsLoading ? (
    <option>Loading products...</option>
  ) : (
    loanProducts.map((type) => {
      const name = type.loan_name || type.type_name;

      return (
        <option key={type.id} value={type.id}>
          {name}
        </option>
      );
    })
  )}
</select> */}

 <label>Bank Account</label>
                  <select className={classes.modalInput} value={bankAccount} onChange={(e) => setBankAccount(e.target.value)}>
                    <option value="">Search or select bank account...</option>
                    {loadingDropdowns ? <option>Loading...</option> : 
                      bankAccounts.map(b => <option key={b.id} value={b.id}>{b.gl_name || b.name || b.account_name}</option>)}
                  </select>
          </div>

           {/* <div className={classes.Group3}>
                      <label>Currency</label>
                      <select
                        value={selectedCurrency}
                        onChange={(e) => setSelectedCurrency(e.target.value)}
                      >
                        <option value="">Select Currency</option>
                        {currencyOptions.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.code || c.name}
                          </option>
                        ))}
                      </select>
                    </div> */}
          

        </div>
          
{/* <div className={classes.Group3} style={{marginTop: '1rem'}}>
            <label>Currency</label>
            <select
              value={selectedCurrency}
              onChange={(e) => setSelectedCurrency(e.target.value)}
            >
              <option value="">Select Currency</option>
              {currencyOptions.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.code || c.name}
                </option>
              ))}
            </select>
          </div> */}
           {/* <div style={{marginTop: '1rem'}} className={classes.Group3}>
                      <label>Payment Mode</label>
                      <select
                        value={selectedPaymentMode}
                        onChange={(e) => setSelectedPaymentMode(e.target.value)}
                      >
                        <option value="">Select Payment Mode</option>
                        {paymentModes.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.code || c.name}
                          </option>
                        ))}
                      </select>
                    </div> */}
       
     <div className={classes.Group3} style={{marginTop: '1rem'}}>
            <label>Date</label>
            <input
              type="date"
              value={transactionDate}
              onChange={(e) => setTransactionDate(e.target.value)}
              required
            />
          </div>

     {/* <div className={classes.Group3} style={{marginTop: '1rem'}}>
            <label>Bank Account</label>
            <div className={classes.searchableDropdown}>
              <input
                type="text"
                placeholder="Search or select debit account..."
                value={debitSearch}
                onChange={(e) => setDebitSearch(e.target.value)}
                onFocus={() => setShowDebitDropdown(true)}
                onClick={() => setShowDebitDropdown(!showDebitDropdown)}
                className={classes.accountInput}
                disabled={debitAccountsLoading}
              />

              {showDebitDropdown && (
                <div
                  className={classes.dropdownList}
                  onMouseLeave={() => setShowDebitDropdown(false)}
                >
                  {debitAccountsLoading ? (
                    <div>Loading accounts...</div>
                  ) : creditAccounts.length === 0 ? (
                    <div>No accounts found</div>
                  ) : (
                    creditAccounts
                      .filter((acc) =>
                        (acc.label || "").toLowerCase().includes(debitSearch.toLowerCase())
                      )
                      .map((acc) => (
                        <div
                          key={acc.value}
                          className={classes.dropdownItem}
                          onClick={() => {
                            setDebitAccount(JSON.stringify({ id: acc.value, gl_code: acc.gl_code }));
                            setDebitSearch(acc.label || "");
                            setShowDebitDropdown(false);
                          }}
                        >
                          {acc.label}
                        </div>
                      ))
                  )}
                </div>
              )}
            </div>
          </div> */}

        <form >
          <div className={classes.footerButtons}>
           <button
              type="button"
              className={classes.resetBtn}
              onClick={() => {
                resetFormFields();
                onClose();
              }}
            >
              Cancel
            </button>

           

            <Button
              variant="success"
              className={classes.submitBtn}
              disabled={isSaving}
              onClick={() => {handleSubmit()}}
            >
              {isSaving ? (
                <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                  <Spinner animation="border" size="sm" /> Saving...
                </span>
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </form>

        <button className={classes.closeBtn} onClick={onClose}>
          <img src={closebtn} alt="close button" />
        </button>
      </div>
    </div>
  );
}

export default SavingsUpload;